import { CHART_FILTER_CHANGE } from 'Shared/actions/timeseries';

export function chart_metrics(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
/*
The timeseries reducer is meant to control all types of timeseries.
The structure is:
timeseries: {
  activity_node_cardinality_outward_[[collaboration_type,meeting]]: {
    data_series: [{…}]
    datasets: [{…}]
    labels: (14) ["Nov 05 - Nov 11", "Nov 12 - Nov 18", "Nov 19 - Nov 25", "Nov 26 - Dec 02", "Dec 03 - Dec 09", "Dec 10 - Dec 16", "Dec 17 - Dec 23", "Dec 24 - Dec 30", "Dec 31 - Jan 06", "Jan 07 - Jan 13", "Jan 14 - Jan 20", "Jan 21 - Jan 27", "Jan 28 - Feb 03", "Feb 04 - Feb 10"]
    metric: "activity_node_cardinality_outward_[[collaboration_type,meeting]]"
    options: {responsive: true, maintainAspectRatio: false, layout: {…}, legend: {…}, scales: {…}}
    timerange: "this_week"
    x_axis_objects: (14) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
  }
}
*/
export function timeseries(state = {}, action) {
  const data = action.data;
  const currentMetric = state[action.metric_code] || {};

  switch (action.type) {
    case 'REQUEST_METRIC_TIMESERIES_RESOURCE':
      return {
        ...state,
        loading: true,
      };
    case 'RECEIVE_METRIC_TIMESERIES_RESOURCE':
      return {
        ...state,
        [action.metric_code]: {
          ...currentMetric,
          ...data,
        },
        loading: false,
      };
    default:
      return state;
  }
}

export function chart_preferences(state = {}, action) {
  const data = action.data;
  const currentPref = state[action.chart] || {};

  switch (action.type) {
    case CHART_FILTER_CHANGE:
      return {
        ...state,
        [action.chart]: {
          ...currentPref,
          ...data,
        },
      };
    default:
      return state;
  }
}
